import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import Loadable from 'ui-component/Loadable';

// vCard routing
const VCardPage = Loadable(lazy(() => import('modules/vcard/pages/VCardPage')));
const VCardTest = Loadable(lazy(() => import('modules/vcard/components/VCardTest')));

// ==============================|| PUBLIC ROUTING ||============================== //

const PublicRoutes = {
    path: 'public',
    element: <MinimalLayout />,
    children: [
        {
            path: 'vcard/:hashedKeyParams',
            element: <VCardPage />
        },
        {
            path: 'vcard-test',
            element: <VCardTest />
        }
    ]
};

export default PublicRoutes;
